'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingIndicator = function LoadingIndicator(_ref) {
    var size = _ref.size,
        enabled = _ref.enabled,
        className = _ref.className,
        fadeEffect = _ref.fadeEffect;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('loading-indicator-comp', {
                'comp-visible': enabled,
                'comp-invisible': !enabled,
                'fade-effect': fadeEffect,
                'no-effect': !fadeEffect
            }, className) },
        _react2.default.createElement('div', { className: (0, _classnames2.default)('load-spin', size) })
    );
};

LoadingIndicator.defaultProps = {
    size: 'sm',
    enabled: true,
    fadeEffect: false
};

LoadingIndicator.propTypes = {
    fadeEffect: _propTypes2.default.bool,
    size: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg']),
    enabled: _propTypes2.default.bool,
    className: _propTypes2.default.string
};

exports.default = LoadingIndicator;
//# sourceMappingURL=index.js.map